import {
  useClickerStateStoreToken,
  useDailyGameStoreToken,
  useDailyRewardsStoreToken,
  useGameStatisticsStoreToken,
  useGameStatusStoreToken,
  useGiftsStoreToken,
  useImprovementsStoreToken,
  useLeaderBoardStoreToken,
  useNavigationClickerModalStoreToken,
  useOnboardingStoreToken,
  useSettingsStoreToken,
  useShareStoreToken,
  useTasksStoreToken,
  useTooltipsStoreToken,
  useUserStoreToken,
  useWinnersStoreToken,
} from '@/di/di.root-container.hooks';

import {useSyncExternalStore} from 'react';

import {DailyRewardsStore} from '@/stores/DailyRewardsStore/DailyRewardsStore';

import {ClickerStateStore} from './ClickerStateStore/ClickerStateStore';
import {DailyGameStore} from './DailyGameStore/DailyGameStore';
import {GameStatisticsStore} from './GameStatisticsStore/GameStatisticsStore';
import {GameStatusStore} from './GameStatusStore/GameStatusStore';
import {GiftsStore} from './GiftsStore/GiftsStore';
import {ImprovementsStore} from './ImprovementsStore/ImprovementsStore';
import {LeaderBoardStore} from './LeaderBoardStore/LeaderBoardStore';
import {NavigationClickerModalStore} from './NavigationClickerModalStore/NavigationClickerModalStore';
import {OnboardingStore} from './OnboardingStore/OnboardingStore';
import {SettingsStore} from './SettingsStore/SettingsStore';
import {ShareStore} from './ShareStore/ShareStore';
import {TasksStore} from './TasksStore/TasksStore';
import {TooltipsStore} from './TooltipsStore/TooltipsStore';
import {UserStore} from './UserStore/UserStore';
import {WinnersStore} from './WinnersStore/WinnersStore';

export function useUserStore(): UserStore {
  const userStore = useUserStoreToken();
  useSyncExternalStore(userStore.subscribe, userStore.getState);
  return userStore;
}

export function useLeaderBoardStore(): LeaderBoardStore {
  const leaderboardStore = useLeaderBoardStoreToken();

  useSyncExternalStore(leaderboardStore.subscribe, leaderboardStore.getState);

  return leaderboardStore;
}

export function useTasksStore(): TasksStore {
  const tasks = useTasksStoreToken();

  useSyncExternalStore(tasks.subscribe, tasks.getState);

  return tasks;
}

export function useImprovementsStore(): ImprovementsStore {
  const improvements = useImprovementsStoreToken();

  useSyncExternalStore(improvements.subscribe, improvements.getState);

  return improvements;
}

export function useDailyGameStore(): DailyGameStore {
  const dailyGameStore = useDailyGameStoreToken();

  useSyncExternalStore(dailyGameStore.subscribe, dailyGameStore.getState);

  return dailyGameStore;
}

export function useNavigationClickerModalStore(): NavigationClickerModalStore {
  const navigationClickerModalStore = useNavigationClickerModalStoreToken();
  useSyncExternalStore(navigationClickerModalStore.subscribe, navigationClickerModalStore.getState);
  return navigationClickerModalStore;
}

export function useClickerStateStore(): ClickerStateStore {
  const clickerStateStore = useClickerStateStoreToken();

  useSyncExternalStore(clickerStateStore.subscribe, clickerStateStore.getState);

  return clickerStateStore;
}

export function useDailyRewardsStateStore(): DailyRewardsStore {
  const dailyRewardsStore = useDailyRewardsStoreToken();

  useSyncExternalStore(dailyRewardsStore.subscribe, dailyRewardsStore.getState);

  return dailyRewardsStore;
}

export function useShareStore(): ShareStore {
  const shareStore = useShareStoreToken();

  useSyncExternalStore(shareStore.subscribe, shareStore.getState);

  return shareStore;
}

export function useGiftsStore(): GiftsStore {
  const giftsStore = useGiftsStoreToken();

  useSyncExternalStore(giftsStore.subscribe, giftsStore.getState);

  return giftsStore;
}

export function useOnboardingStore(): OnboardingStore {
  const onboardingStore = useOnboardingStoreToken();

  useSyncExternalStore(onboardingStore.subscribe, onboardingStore.getState);

  return onboardingStore;
}

export function useSettingsStore(): SettingsStore {
  const settingsStore = useSettingsStoreToken();

  useSyncExternalStore(settingsStore.subscribe, settingsStore.getState);

  return settingsStore;
}

export function useTooltipsStore(): TooltipsStore {
  const tooltipsStore = useTooltipsStoreToken();

  useSyncExternalStore(tooltipsStore.subscribe, tooltipsStore.getState);

  return tooltipsStore;
}

export function useGameStatusStore(): GameStatusStore {
  const gameStatusStore = useGameStatusStoreToken();

  useSyncExternalStore(gameStatusStore.subscribe, gameStatusStore.getState);

  return gameStatusStore;
}

export function useGameStatisticsStore(): GameStatisticsStore {
  const gameStatisticsStore = useGameStatisticsStoreToken();

  useSyncExternalStore(gameStatisticsStore.subscribe, gameStatisticsStore.getState);

  return gameStatisticsStore;
}

export function useWinnersStore(): WinnersStore {
  const winnersStore = useWinnersStoreToken();

  useSyncExternalStore(winnersStore.subscribe, winnersStore.getState);

  return winnersStore;
}
